import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'shared-circle-counter',
    templateUrl: './circle-counter.shared.component.html',
    styleUrls: ['./circle-counter.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircleCounterComponent {
    @Input() public size: number = 150;
    @Input() public thickness: number = 8;
    @Input() public total!: number;
    @Input() public current!: number;

    public get totalSize(): number {
        return this.size;
    }

    public get cxcy(): number {
        return (this.size / 2);
    }

    public get radius(): number {
        return this.cxcy - (this.thickness / 2);
    }

    public get circumference(): number {
        return this.radius * 2 * Math.PI;
    }

    public get progress(): number {
        if (typeof this.total !== 'number' || typeof this.current !== 'number') return this.circumference;
        return this.circumference - this.currentToPercent / 100 * this.circumference;
    }

    public get progressFull(): number {
        return 0;
    }

    public get currentToPercent(): number {
        return (this.current || 0) * 100 / (this.total || 0);
    }
}
